// contains configuration options used to render the Chart.js charts for a selected park.

export const options = (labels: any) => {
  return ({
    maintainAspectRatio: false,
    indexAxis: "y" as const,
    scales: {
      y: {
        ticks: {
          font: {
            size: 11,
          },
          callback: (e: any) => {
            // Custom callback function to wrap labels to a maximum line length of 15 characters
            // Access the label at the correct index
            const label = labels[e]
            // If the label is less than or equal to 15 characters in length, return that label
            if (label.length <= 15) {
              return label
            } else {
              let startIndex = 0
              const labelArray = []
              // Iterate over the label string and add substrings of 15 characters or less, separated by space characters
              while (startIndex < label.length) {
                let endIndex = startIndex + 15;
                if (endIndex + 1 >= label.length) {
                  labelArray.push(label.substring(startIndex).trim())
                } else {
                  while (endIndex > startIndex && label[endIndex] !== ' ') {
                    endIndex--;
                  }
                  if (endIndex === startIndex) {
                    endIndex = startIndex + 15
                  }
                  labelArray.push(label.substring(startIndex, endIndex).trim());
                }
                startIndex = endIndex + 1;
              }
              return labelArray
            }
          }
        },
      },

      x: {
        ticks: {
          callback: function (value: any, index: any, ticks: any) {
            return value;
          },
        },
        min: 0
      },
    },
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    redraw: true,
    plugins: {
      title: {
        display: false,
        text: "Access Demographics",
      },
      legend: {
        display: false,
      },
      datalabels: {
        display: true,
        color: "black",
        formatter: function (val: any) {
          return val.toLocaleString();
        },
      },
    }
  })
};

export const demographicsInServiceArea: any = [
  {
    displayName: "White*",
    value: "SUM_WHITE_SVC",
    amount: 0,
  },
  {
    displayName: "Black*",
    value: "SUM_BLACK_SVC",
    amount: 0,
  },
  {
    displayName: "Native American*",
    value: "SUM_AMERINDSVC",
    amount: 0,
  },
  {
    displayName: "Asian*",
    value: "SUM_ASIAN_SVC",
    amount: 0,
  },
  {
    displayName: "Pacific Islander*",
    value: "SUM_PACIFICSVC",
    amount: 0,
  },
  {
    displayName: "Other Race*",
    value: "SUM_OTHRACESVC",
    amount: 0,
  },
  {
    displayName: "Two or More Races*",
    value: "SUM_RACE2UPSVC",
    amount: 0,
  },
  {
    displayName: "Hispanic",
    value: "SUM_HISP_SVC",
    amount: 0,
  },
];

export const ageGroupInServiceArea: any = [
  {
    displayName: "Youth (<20)",
    value: "SUM_KIDSVCA",
    amount: 0,
  },
  {
    displayName: "Adults (20-64)",
    value: "SUM_YOUNGPROSVCA",
    amount: 0,
  },
  {
    displayName: "Seniors (>64)",
    value: "SUM_SENIORSVCA",
    amount: 0,
  },
];

export const incomeGroupInServiceArea: any = [
  {
    displayName: "Low Income (<75% MAI)",
    value: "SUM_HHILOWSVCA",
    amount: 0,
  },
  {
    displayName: "Medium Income (75%-125% MAI)",
      value: "SUM_HHIMEDSVCA",
    amount: 0,
  },
  {
    displayName: "High income (>125% MAI)",
    value: "SUM_HHIHIGHSVCA",
    amount: 0,
  },
];

export const demoLabels = [
  "White*",
  "Black*",
  "Native American*",
  "Asian*",
  "Pacific Islander*",
  "Other Race*",
  "Two or More Races*",
  "Hispanic*",
];

export const ageLabels = ["Youth (<20)", "Adults (20-64)", "Seniors (>64)"];

export const incomeLabels = [
  "Low Income (<75% MAI)",
  "Medium Income (75%-125% MAI)",
  "High income (>125% MAI)",
];

export const colors = [
  "#E7F4B8",
  "#BEDA58",
  "#5DBA54",
  "#1D8363",
  "#57C5F8",
  "#2EA0D4",
  "#1989BC",
];
